import { MarketplacePlaceholder } from '../../components'

export default function MarketplaceImportExportPage() {
  return (
    <MarketplacePlaceholder
      title="Import coming soon"
      description="Bulk CSV import is on the roadmap. You can export your current item list from the All Items page today."
      icon="📦"
    />
  )
}
